import React from 'react';
import {navigate} from '@reach/router';
import {useModal} from 'contexts/modal';
import FormContactInfoBase from './FormContactInfoBase';
import axios from 'axios';
import {submitForm} from 'utils/forms';
import track, {identify} from 'utils/track';
import {useUserDispatch} from 'contexts/user';

import './OptinFormChallenge.scss';

export default function OptinFormChallenge({
  apiUrl,
  orderApiUrl,
  contactInfoFormButtonText = undefined,
  contactInfoFormDisclaimer = undefined,
  contactInfoFormHeader = undefined,
  contactInfoFormSmsDisclaimer = undefined,
  disableNavigate = false,
  entry = 'default',
  navigateUrl,
  optinFormId,
  offerId,
  offerPaymentOptionId,
  siteId,
  hiddenValues = {}
}) {
  const modalProps = useModal();
  const userDispatch = useUserDispatch();

  const onComplete = React.useCallback(() => {
    !disableNavigate && navigate(`${navigateUrl}${entry !== 'default' ? `?entry=${entry}` : ''}`);
    modalProps.toggle();
  }, []);

  return (
    <FormContactInfoBase
      {...{
        contactInfoFormHeader,
        contactInfoFormButtonText,
        contactInfoFormDisclaimer,
        contactInfoFormSmsDisclaimer
      }}
      includeLastName
      onSubmit={({firstName, lastName, email, smsNumber, ...values}, actions) => {
        return submitForm(
          {
            firstName,
            lastName,
            email,
            smsNumber: smsNumber.replace(/\D/g, ''),
            entry,
            ...values,
            ...hiddenValues
          },
          optinFormId,
          apiUrl,
          siteId
        )
          .then(({data}) => {
            identify(data.proxy_data.user.uuid, {
              id: data.proxy_data.user.uuid,
              firstName: values.firstName,
              email: values.email,
              ...(smsNumber ? {phone: smsNumber} : {})
            });
            track('User Registered', {
              property: siteId,
              entryPoint: entry,
              label: `${siteId} - ${entry}`,
              registrationId: data.proxy_data.registrationId
            });
            return userDispatch({
              type: 'SET_USER',
              payload: {
                firstName: values.firstName,
                email: values.email,
                registrationId: data.proxy_data.registrationId,
                mcFormReqUUID: data.proxy_data.mc_form_uuid,
                uuid: data.proxy_data.user.uuid
              }
            });
          })
          .then(() => {
            return axios.post(`${orderApiUrl}/orders/`, {
              BillingAddress: {postalCode: '', country: 'US'},
              BumpOfferIds: [],
              BumpOfferQuantities: [],
              isGift: false,
              giftRecipient: {},
              User: {firstName, lastName, email},
              OfferId: parseInt(offerId),
              OfferPaymentOptionId: parseInt(offerPaymentOptionId),
              PaymentMethod: {gateway: 'manual', gatewayToken: 'manual'},
              Quantity: 1,
              UserPaymentMethodId: null,
              deviceData: ''
            }).catch((e) => {
              console.error(e);
            })
          })
          .then(() => onComplete())
          .catch((e) => {
            actions.setStatus({error: e});
            actions.setSubmitting(false);
          });
      }}
    />
  );
}
